module.exports = __webpack_public_path__ + "static/ru-sm-1-e848ec065dc3005fbd529771f45d3fb1.png";